import { DataTable } from "@msuite/ui/table";
import { useReturnOrderFiles } from "@/hooks/use-return-order-files";
import { returnOrderSheetsTableColumns } from "./table-config";

/** Props Interface */
interface ReturnOrderSheetsProps {
	returnOrderId: string;
}

/**
 * The sheet a return run prints — one PDF carrying the run's QR code and one page per lorry.
 *
 * This is where the paper actually leaves the system: the sheet rides in the cab and is what the
 * warehouse scans when the lorry arrives, because the per-shipment labels that went out with the
 * material are gone by the time a site is cleared. A run whose sheet cannot be opened cannot be
 * worked.
 *
 * **One row is the normal case.** The run's sheet is rendered again whenever its fleet changes and
 * the previous file is removed, so what stands here is the document that names the trucks actually
 * going — there is no older sheet to mistake it for.
 */
export function ReturnOrderSheets({ returnOrderId }: ReturnOrderSheetsProps) {
	/** Query */
	const { files, isLoading, refetch, queryKey } = useReturnOrderFiles(returnOrderId);

	/** Render */
	return (
		<DataTable
			data={files}
			columns={returnOrderSheetsTableColumns}
			queryKey={queryKey}
			isLoading={isLoading}
			refetch={refetch}
			persistenceKey="return-order-sheets-table"
			menu={null}
		/>
	);
}
